// Mirrors withWmsFallback in vue3/vue_src/components/tiptap/mapPreviewLayers.js.

// True when every pixel is transparent or the same colour, what a WMS returns when it fails silently.
export function isBlankPixels(data) {
    let opaque = false;
    for (let i = 3; i < data.length; i += 4) {
        if (data[i] !== 0) { opaque = true; break; }
    }
    if (!opaque) return true;
    for (let i = 4; i < data.length; i += 4) {
        if (data[i] !== data[0] || data[i + 1] !== data[1] || data[i + 2] !== data[2] || data[i + 3] !== data[3]) return false;
    }
    return true;
}

// Reads a loaded tile's pixels; without a crossOrigin load the canvas is tainted and the tile counts as delivered.
export function isBlankTile(tile) {
    try {
        const canvas = document.createElement("canvas");
        canvas.width = tile.naturalWidth;
        canvas.height = tile.naturalHeight;
        const context = canvas.getContext("2d");
        context.drawImage(tile, 0, 0);
        return isBlankPixels(context.getImageData(0, 0, canvas.width, canvas.height).data);
    } catch (error) {
        return false;
    }
}

// Switches a WMS layer to its fallback service once a load cycle ends with only failed or blank tiles.
// A fallback with `blank_is_failure: false` (overlays that are legitimately empty) switches on tile errors only.
export function withWmsFallback(layer, fallback, { isBlank = isBlankTile } = {}) {
    const blankIsFailure = fallback.blank_is_failure !== false;
    let switched = false, delivered = false, failed = false;
    layer.on("tileload", (event) => {
        if (switched || delivered) return;
        if (blankIsFailure && isBlank(event.tile)) failed = true;
        else delivered = true;
    });
    layer.on("tileerror", () => { failed = true; });
    layer.on("load", () => {
        if (switched || delivered || !failed) return;
        switched = true;
        // The primary's custom style names its own layer, which the fallback service does not have.
        delete layer.wmsParams.sld_body;
        layer.setParams({ layers: fallback.layers, styles: fallback.styles || "" }, true);
        layer.setUrl(fallback.url);
    });
    return layer;
}
